// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Gn_S","right":"Footer_right__hOfDT","buttons":"Footer_buttons__1K8UB"};